<template>
  <ModalPolicy show logoutable @completed="onCompleted" />
</template>

<script>
import ModalPolicy from './components/ModalPolicy.vue';
import { userInfoMixin } from '@/mixins/userInfoMixin';
import { CatalogConsent } from '@/models/catalog/CatalogConsent';

export default {
  components: {
    ModalPolicy
  },
  mixins: [userInfoMixin],

  watch: {
    user: {
      immediate: true,
      handler: 'checkConsentUser'
    }
  },

  methods: {
    async checkConsentUser() {
      if (this.user) {
        try {
          const response = await CatalogConsent.api().requestConsents();
          const data = response?.response?.data?.data;
          
          const hasConsented = data?.consents ? data.consents.length === 0 : true;

          // If they already consented to everything, redirect them away
          if (data && hasConsented) {
            this.$router.replace({ name: 'learning-unit' });
          }
        } catch (error) {
          console.error('Failed to check user consent:', error);
        }
      }
    },

    async onCompleted(payload) {
      try {
        await CatalogConsent.api().submitConsents(payload);
        this.$router.replace({ name: 'learning-unit' });
      } catch (error) {
        console.error('Failed to submit user consents:', error);
      }
    }
  }
};
</script>
